export const projects = [
  {
    title: "NBA-Project",
    subtitle: "Predict the next Hall of Fame",
    description:
      "PREDICTING THE NEXT HALL OF FAME PLAYER USING LINEAR REGRESSION AND WEB SCRAPING ",
    image: "https://lh3.googleusercontent.com/pw/ABLVV84uNHk39qMbxKPs5frfJ4vGt9gzlypx4qIQa2u1P0fMeMXQmd9lsekJkd2mlMITXnlahFS4EsE6PspKI0O8hBBJOgq9F4W5Ejh6sBnYdgzt2N6bkdM=w1920-h1080",
    link: "https://github.com/Oluwa-bowry/NBA_project",
  },
  {
    title: "Blackcofferscraper",
    subtitle: "Data scraping, wrangling and analysis",
    description:
      "Web scraping and analysis with python packages (selenium, scrapy, numpy, pandas, matplotlib and seaborn).",
    image: "https://lh3.googleusercontent.com/pw/ABLVV86gMl5x_SRx_UP9EC0VQD26GmAaGbWxYn33aljsZAmAWHSyJYnay_JNQjo4ebSE9GMfN7ZZRMcOQVbbdxPQZcIQ8Ir9aAg-V5nocCSOiA5ffHOfNDc=w1920-h1080",
    link: "https://drive.google.com/drive/folders/1SUSAI_gZGZDvbg81HZDvh6uZGLTc1PUg?usp=sharing",
  },
  {
    title: "Automatic Speak Recognition",
    subtitle: "Speech recognition model in noisy environment",
    description:
      "To develop a machine learning techniques that can improve the robustness and accurracy in the presence of noise,",
    image: "https://lh3.googleusercontent.com/pw/ABLVV84STyzII-ipYL3N6XuQWiauQ4Bm6CoavtOSpqRspkTBwC_T0DUIoyYIx_ud87hTlcbBYMDEkg4Ga1lcMiIJoOx_2y9AgSjRSxnlx9zG1cDRFW-OE94=w1920-h1080",
    link: "https://drive.google.com/drive/folders/1vKRgnY5KR5WeizjvtXuiBzCWlhJTfEMv?usp=sharing",
  },
  {
    title: "Cell Segmentation",
    subtitle: "Application of U-Net in Medical Image Analysis",
    description:
      "Training a U-Net model for multi-class segmentation of living and dead cells in medical images",
    image: "https://lh3.googleusercontent.com/pw/ABLVV85fvtcXJFbpngRq8ntpcqefAqsBKiz_jL_bkR-ZbsPW6PH_q8jYXjMRKm_qEjkyMaGhqtDDkgJQDInGoZqTCi09jUO1AZ70GpfaIWXSP72sdjWbd0Y=w1920-h1080",
    link: "https://medium.com/@clement.bowry/application-of-u-net-in-medical-image-analysis-bf12cf36cbc6",
  },
];

export const testimonials = [
  {
    quote:
      "Your work ethcis, I can vouch for. You did a great project. johnsonmoyinoluwa@gmail.com",
    //image: "https://randomuser.me/api/portraits/men/1.jpg",
    name: "Johnson Moyinoluwa",
    company: "Mcjohnson concept",
  },
  {
    quote:
      "Good job welldone. adeosun@gmail.com",
    // image: "https://randomuser.me/api/portraits/men/94.jpg",
    name: "Adeosun Oluwaseyi",
    company: "SERG",
  },
];

export const skills = [
  "Data Wrangling",
  "Database Design Management",
  "Statistical Analysis",
  "Data Visualization",
  "Data Analysis",
  "Programming",
  "Machine Learning",
  "Deep Learning",
  "Big Data Processing",
  "Communication Skills",
  "Problem Solving",
  "Critical Thinking",
];



// WEBPACK FOOTER //
// ./src/data.js